/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Advanced_BadgeInputs */



/**
* | output |
* | --- |
* | "Advanced" |
*
* @param {Audio_Description_Export_Advanced_BadgeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_advanced_badge = /** @type {((inputs?: Audio_Description_Export_Advanced_BadgeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Advanced_BadgeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Avancé")
	if (locale === "de") return /** @type {LocalizedString} */ ("Fortschrittlich")
	if (locale === "it") return /** @type {LocalizedString} */ ("Avanzato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Передовой")
	if (locale === "es") return /** @type {LocalizedString} */ ("Avanzado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("先进的")
	if (locale === "ja") return /** @type {LocalizedString} */ ("高度な")
	if (locale === "hi") return /** @type {LocalizedString} */ ("विकसित")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Avançado")
	return /** @type {LocalizedString} */ ("Advanced")
});